<template>
    <div class="hidden lg:block w-next-nav fixed h-menu bg-next-dark-gray z-10">
        <div class="flex flex-col h-full justify-between text-white">
            <div class="flex-grow grid grid-rows-5">
                <MenuButton v-if="showHome" :to="{name:'Home'}" iconClass="icon-home" tooltip="Home"></MenuButton>
                <ProfileMenuButton class="row-start-5" :notification="meCounters?.notification_counter > 0"></ProfileMenuButton>
            </div>
        </div>
    </div>

    <div v-if="$store.state.menu_visible" class="lg:hidden fixed z-10 inset-0 bg-gray-500 bg-opacity-90" @click="toggle">
        <div class="flex flex-col text-white text-4xl pl-12 pt-14">
            <div v-if="showHome" class="py-4">
                <i class="self-center text-md icon-home"></i>
                <router-link :to="{name:'Home'}" class="pl-4">HOME</router-link>
            </div>
            <div class="py-4">
                <i class="self-center fa fa-circle text-md"></i>
                <router-link :to="{name:'ProfiloUtente'}" class="pl-4">PROFILO</router-link>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import MenuButton from "@/components/MenuButton.vue";
import ProfileMenuButton from "@/components/ProfileMenuButton.vue";
import {mapGetters} from 'vuex';

@Options({
    name:'MainMenu',
    computed: {
        ...mapGetters([
            'meCounters',
        ]),
    },
    components: {
        MenuButton,
        ProfileMenuButton
    },
    props: {
        showHome: {
            default:true,
            type:Boolean
        }
    }
})
export default class MainMenu extends Vue {
    private $store: any;
    private meCounters!: any;

    toggle(){
        this.$store.commit('toggle_menu')
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
